import CustomPlugin from './CustomPlugin';

// COMPONENTS
import SkyClickPlayer from "../../components/custom/SkyClickPlayer";
import {PlayerComponentHookType} from "../../components/wrappers/PlayerComponentWrapper";
import mergeOptions from "../../utils/wrappers/merge-options";
import {
    ResolutionSwitcherEventTypes,
    default as ResolutionSwitcherPluginDecorator
} from "../decorators/ResolutionSwitcherPluginDecorator";

import * as Cookies from "js-cookie";
import Constants from "../../utils/Constants";

export default class ResolutionCookieStoragePlugin extends CustomPlugin{

    static readonly PLUGIN_NAME = 'resolutionCookieStorage';

    static autoStart = true;

    static bootingStaticApi() {
        super.bootingStaticApi();

        SkyClickPlayer.hookManagerInstance.add<PlayerComponentHookType>('BEFORE_SETUP', (videoEl:Element, options: any) => {
            return this.processOptions(options);
        });
    }

    static processOptions(options:any){

        options.plugins.resolutionCookieStorage = options.plugins.resolutionCookieStorage || {};

        // extend default configuration with custom configuration
        options.plugins.resolutionCookieStorage = mergeOptions({},{
            activate: true,
            cookieName: Constants.NAMESPACE_LOCALSTORAGE_COOKIE + '_last_resolution',
            cookieExpires: 30 // The quality is remembered by default for 1 month
        },options.plugins.resolutionCookieStorage);

        return options;

    }

    protected resolutionSwitcherPluginDecorator:ResolutionSwitcherPluginDecorator;

    init() {
        // PLUGIN CODE
        if(this.options.activate){
            this.resolutionSwitcherPluginDecorator = this.skyClickPlayer.pluginManager.getPluginDecorator<ResolutionSwitcherPluginDecorator>('resolution-switcher');
            this.skyClickPlayer.eventManager.addListener<ResolutionSwitcherEventTypes>('RESOLUTION_CHANGED', this.updateStore.bind(this));
        }
    }

    public updateStore(){
        let currentResolution = this.resolutionSwitcherPluginDecorator.getCurrentResolution();
        Cookies.set(this.options.cookieName, currentResolution.label, { expires: this.options.cookieExpires } );
    }

}

// *** extend player declaration with new plugin function

// interface, that base on plugin class with additional startup function declaration
interface WithStartupDeclaration extends ResolutionCookieStoragePlugin{
    (options?: Object): ResolutionCookieStoragePlugin
}
// Using of Type Scripts "Module Augmentation" https://www.typescriptlang.org/docs/handbook/declaration-merging.html#module-augmentation
// Extend VideoJSPlayer declaration with extend function by plugin
// So TypeScript compiler support the usage of this dynamic added function, because this plugin is added to the
declare global {
    interface VideoJSPlayer{
        resolutionCookieStorage:WithStartupDeclaration;
    }
}



// WEBPACK FOOTER //
// ./src/app/plugins/custom/ResolutionCookieStorage.ts